var arrayWithHoles = require("./arrayWithHoles");

var iterableToArrayLimit = require("./iterableToArrayLimit");

var nonIterableRest = require("./nonIterableRest");

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/slicedToArray.js
// module id = 40
// module chunks = 0